// Japanese language file
export const JA = {
  preparing_zip: "ZIPを準備しています…",
  compressing: "圧縮しています…",
  info_icon: "完了としてマークされると、追加のメンバーは参加または追加できなくなり、すべてのチャットグループが無効化されます。プロジェクトは、すべてのチャットグループとデータとともに、無効化された状態でアクセス可能なままであることに注意してください。",
  mark_is_done: "プロジェクトを完了としてマークしてもよろしいですか？マークされると、追加のメンバーは参加または追加できなくなり、すべてのチャットグループが無効化されます。プロジェクトは、すべてのチャットグループとデータとともに、無効化された状態でアクセス可能なままであることに注意してください。",
  mark_not_done: "プロジェクトを再開してもよろしいですか？開いているとしてマークされると、追加のメンバーが参加または追加でき、すべてのチャットグループが再有効化されます。",
  mark_as_completed: "プロジェクトを完了としてマーク",
  room_completed: "プロジェクト完了",
  room_members: "プロジェクトメンバー",
  deactivated_rooms: "無効化されたプロジェクト",
  deactivated_chats: "無効化されたチャット",
  completed_rooms: "完了したプロジェクト",
  request_to_join_a_room: 'プロジェクトへの参加リクエスト',
  wants_to_rejoin_room: 'UsernameがプロジェクトRoomnameに再参加を希望しています。',
  invited_you_to_join_room: 'UsernameがあなたをプロジェクトRoomnameに招待しました。',
  restart: "再起動",
  update_text: "新しいアップデートが利用可能です。再起動をクリックしてアップデートをインストールしてください。",
  update_availble: "アップデート利用可能",
  Loading: "読み込み中...",
  logout: "ログアウト",
  back: '戻る',
  company_list: "会社一覧",
  followers: "フォロワー",
  followings: "フォロー中",
  article: "記事",
  companies: "会社",
  one_to_one_chat: " 1対1チャット",
  profile: "プロフィール",
  company: "会社",
  company_selection: "会社選択",
  home: "ホーム",
  contact: "連絡先 ",
  add_company: "会社を追加 ",
  add_project: "プロジェクトを追加 ",
  capacities: "能力 ",
  work_area: "作業エリア",
  company_services: "会社サービス",
  website: "ウェブサイト",
  search_contacts: "連絡先を検索",
  add_or_join_a_company: "会社を追加または参加",
  follow: "フォロー",
  following: "フォロー中",
  like: "いいね",
  company_contacts: "会社連絡先",
  leave_the_company: "会社を退会",
  news: "ニュース",
  earlier: "以前",
  action: "アクション",
  another_action: "別のアクション",
  something_else: "その他",
  search: "検索",
  search_rooms: "プロジェクトを検索",
  search_articles: "記事を検索",
  contacts: "連絡先",
  suggestions: "提案",
  project_list: "プロジェクト一覧",
  search_results: "検索結果",
  add_or_join_project: "プロジェクトを追加または参加",
  details: "詳細",
  your_position_within_company: "会社内での役職を選択してください。",
  close_modal: "閉じる",
  map: "地図",
  or: "または",
  name: "名前*",
  street: "通り*",
  house_number: "番地",
  postal_code: "郵便番号",
  city: "市区町村*",
  opened_by: "開設者:",
  project_No: "プロジェクト番号: ",
  building_type: "建物タイプ*",
  building_types: "建物タイプ",
  add_join: "追加/参加",
  mandatory_fiels: "*必須項目",
  invalid_fiels: "この項目は必須です",
  add_or_join_company: "会社を追加または参加",
  name_of_the_company: "会社名",
  edit_company_details: "会社詳細を編集",
  branch_of_the_building_industry: "建設業界の分野",
  corporate_form: "法人形態",
  position_within_company: "会社内の役職",
  request_confirmation: "保留中のプロジェクトリクエスト",
  company_e_mail: "会社メール",
  type_of_filter: "フィルターを入力...",
  setting: "設定",
  dashboard: "ダッシュボード",
  settings: "設定",
  views: "閲覧数",
  times_seen: "回閲覧",
  see_more: "...もっと見る",
  see_less: "...閉じる",
  in_search: "検索で",
  reset_password: "パスワードをリセット",
  submit: "送信",
  password: "パスワード",
  email: "メール",
  confirm_password: "パスワードを確認",
  reset_email: "メールをリセット",
  update: "更新",
  new_email: "新しいメール",
  kjuup_message: "Kjuup メッセージ",
  delete_profile: "プロフィールを削除しますか？",
  my_position: "私の役職:",
  add: "追加",
  owner_company_admin: "会社管理者:",
  owner_company_admin_new: "会社管理者",
  mutual_contact: "共通の連絡先",
  mutual_contacts: "共通の連絡先",
  co_owner: "共同所有者",
  managing_director: "取締役",
  associate: "アソシエート",
  secretary: "秘書",
  employee: "従業員",
  project_manage: "プロジェクトマネージャー",
  auto_chat_translation: "自動チャット翻訳",
  translate_room_group_names: "チャットグループ名を翻訳",
  translate_room_group_names_info: "有効にすると、チャットグループ名がインターフェース言語に自動翻訳されます。",
  default_view_email: "Default View: E-Mail",
  default_view_email_info: "有効にすると、アプリを開いた時にメッセージの代わりにメールタブがデフォルトで開きます。",
  integrate_email_in_messages: "Integrate E-Mail in Messages",
  integrate_email_in_messages_info: "When enabled, emails from all connected accounts will appear alongside your chat messages, sorted by date.",
  language: "言語",
  english: "英語",
  german: "ドイツ語",
  french: "フランス語",
  italian: "イタリア語",
  change_language: "言語を変更",
  my_companies: "私の会社",
  employees: "従業員",
  invite_with_a: "Kjuupに招待",
  add_member: "メンバーを追加",
  add_user: "ユーザーを追加",
  send_location: "場所を送信",
  assign_admin_rights: "管理者権限を調整",
  deactivate_company: "会社を無効化",
  remove_employees: "従業員を削除",
  remove_members: "メンバーを削除",
  no_user_found: "ユーザーが見つかりません！",
  approve: "承認！",
  deselect_all: "すべての選択を解除",
  select_all: "すべて選択",
  translation_on_building_projects: "プロジェクトでの翻訳",
  reported_capacities: "報告されたサービス",
  up_to_50m_exact: "最大50m正確",
  company_details_service: "会社サービス",
  company_contact: "会社連絡先",
  invite_with_link: "Kjuupに招待",
  share_link: "リンクを共有",
  share_company_link: "リンクを共有",
  qr_code: "QRコード",
  copy_link: "リンクをコピー",
  cancel_link: "リンクをキャンセル",
  who_has_confirmed_services: "誰があなたのサービスを確認しましたか？",
  projectss: "プロジェクト",
  add_services: "サービスを追加",
  services: "サービス",
  save_text: "保存",
  share_on: "共有先:",
  articlen: "記事",
  invite_user_to_confirm_service: "ユーザーを招待して会社のサービスを確認してもらいます。",
  link_copied: "リンクをコピーしました！",
  email_copied: "メールをコピーしました！",
  personal_article: "個人記事",
  company_article: "会社記事",
  characters_remaining: "残り文字数",
  optional_information: "オプション情報",
  project: "プロジェクト",
  projects: "プロジェクト...",
  abort: "破棄",
  preview: "プレビュー",
  post: "投稿",
  of: "の",
  remove: "削除",
  free_capacity: "求人ポータル",
  current_status_overview: "現在のステータス概要",
  report_capacities: "サービスを報告",
  report_text: "報告",
  search_capacities: "請負業者を検索",
  add_project_user: "プロジェクトユーザーを追加",
  media: "メディア",
  links: "リンク",
  docs: "ドキュメント",
  featured_products: "注目製品...",
  title: "タイトル",
  text: "テキスト",
  feed_details: "フィード詳細",
  add_employee: "従業員を追加",
  latest: "最新",
  my_projects: "私のプロジェクト",
  cancel: "キャンセル",
  continue: "続ける",
  role_in_the_building_industry: "建設業界での役割",
  als: "として",
  join: "参加",
  find: "検索",
  request_to_join_a_company: "会社への参加リクエスト",
  wants_to_join_the_company: "会社に参加したい",
  filter_by: "フィルター",
  ok: "OK",
  close: "閉じる",
  weekly_statistics: "週間統計",
  is_following_you: "があなたをフォローしています。",
  as: "として",
  has_joined_the: "が会社に参加しました",
  has_looked_at_your_profile: "があなたのプロフィールを見ました。",
  time: "時間",
  in_searches_in_past_week: "先週の検索で。",
  has_liked_your_article: "があなたの記事にいいねしました。",
  has_published_a_new_article: "が新しい記事を公開しました。",
  you: "あなた",
  all_views: "すべての閲覧",
  all_profile_views: "すべてのプロフィール閲覧",
  mutual_company: "共通の会社",
  artical_text: "記事を書く...",
  you_have_appeared: "あなたが表示されました",
  your_request_at_the_company: "会社でのあなたのリクエスト",
  times_you_have_appeared_in_searches: "回検索で表示されました",
  appear_more_often_in_searches: "検索でより頻繁に表示される",
  you_have_been_found: "あなたが見つかりました",
  improve_profile: "プロフィールを改善",
  choose_existing_contact_for_single_chat: "1対1チャットの既存の連絡先を選択:",
  in_order_to_add_new_contacts: "新しい連絡先を追加するには、プロフィールページで新しい連絡先を検索してください。",
  times_in_searches_in_the_last_week: "先週の検索で回。プロフィールを更新し、より見つけやすくするために詳細を追加してください。",
  has_been_confirmed: "が確認されました。",
  have_joined_the: "が参加しました ",
  building_project: " 建設プロジェクト。",
  select_with_which_company_you_want_to_connect_to_the_project: "代表する会社を選択してください。これは他の参加者に表示されます。",
  select_with_which_company_you_want_to_connect_to_the_chat: "代表する会社を選択してください。これは他の参加者に表示されます。",
  select_internal_section: "内部セクションを選択してください",
  select_profile_image: "プロフィール画像を選択",
  share_user: "ユーザーを共有",
  contact_sender_message: "このリンクを共有して、Kjuupの非メンバーをKjuupに招待します。このリンクは複数の人が登録に使用できます。",
  project_sender_message: "このリンクを共有して、Kjuupの非メンバーをプロジェクト「プロジェクト名」に招待します。このリンクは複数の人が登録してKjuupのプロジェクト「プロジェクト名」に参加するために使用できます。",
  company_sender_message: "このリンクを共有して、Kjuupの非メンバーを会社会社名に招待します。このリンクは複数の人が登録してKjuupの会社に参加するために使用できます。",
  contact_receivers_message: "Kjuupに参加する招待リンク。kjuupに登録するにはリンクをクリックしてください。",
  iphone: "iPhone:",
  iphone_recivers_message: "Apple App Store経由でKjuupをインストールする場合、登録できるようにするには、ダウンロード成功後にこのリンクをクリックする必要があります。",
  project_receivers_message: "Kjuupのプロジェクト「プロジェクト名」に参加する招待リンク。Kjuupに登録してプロジェクト「プロジェクト名」に参加するにはリンクをクリックしてください。",
  company_receivers_message: "Kjuupの会社会社名への招待リンク。Kjuupに登録して会社会社名に参加するにはリンクをクリックしてください。",
  sign_in: "サインイン",
  enter_your_email_add: "メールアドレスを入力",
  forgot_password: "パスワードを忘れた",
  dont_have_account: "アカウントをお持ちでないですか？",
  register: "登録",
  get_app: "アプリを取得",
  registration: "登録",
  dep_ing: "Dipl.-Ing.",
  dr: "博士",
  dr_ing: "Dr.-Ing.",
  dep_ing_arc: "Dipl.-Ing. Architect",
  prof: "教授",
  first_name: "名",
  last_name: "姓",
  have_an_account: "アカウントをお持ちですか？",
  when_register_you_agree: "登録すると、以下に同意したことになります",
  term_of_use: "利用規約",
  to: "に。",
  in_our: "私たちの",
  data_policy: "データポリシー",
  they_find_out: "彼らが知る、",
  we_provide_store_data: "情報の収集、処理、保存方法。",
  leaving_company_text: "本当に会社を退会しますか？会社を退会すると、関連するすべてのプロジェクトとチャットグループも退会します。いつでも別の会社でこれらのプロジェクトに再参加できます。",
  delete_profile_text: "本当にプロフィールを削除しますか？プロフィールを削除すると、会社、プロジェクト、チャットへのすべての接続が削除されます。いつでも新しいプロフィールを作成できます。",
  confirm: "確認",
  reject: "拒否",
  requet_to_leave: "退会リクエスト",
  choose: "選択",
  your_add_member: "メンバーを追加",
  if_you: "もし",
  can_not_find: "ここで連絡先が見つかりません。",
  please_wait: "お待ちください..",
  imprint_gtc: "インプリント/利用規約",
  register_confirm_popup: "ログインする前にKjuupのメールアドレスを確認してください。確認リンクを送信しました。届いていない場合は迷惑メールフォルダもご確認ください。",
  PENDING_GROUP_USER: "プロジェクトへの招待が確認された後にのみメッセージを受信します。プロジェクトへの招待が確認されると、追加のメッセージが表示されます。",
  PENDING: "プロジェクトへの招待確認保留中",
  denied_group_chat: " がプロジェクト招待を拒否し、このグループを退会しました。",
  joined_group_chat: " がこのグループに参加しました",
  you_joined_group_chat: "あなたがこのグループに参加しました。",
  Others: "その他",
  LEFT_GROUP: "がこのチャットグループを退会しました。",
  YOU_LEFT_GROUP: "がこのチャットグループを退会しました。",
  days: "日",
  day: "日",
  hour: "時間",
  hide_project: "プロジェクトを非表示",
  hide_project_popup_text: "プロジェクトを非表示にすると、Kjuup内で見つけることができません。プロジェクトのメンバーのみが新しいユーザーをプロジェクトに招待できます。",
  branch: "分野",
  photo_video_media_lib: "写真 - 動画メディアライブラリ",
  document: "ドキュメント",
  location_meeting: "場所 / 会議",
  all_member_of_project: "プロジェクトのすべてのメンバー",
  pending_request: "保留中のプロジェクトリクエスト",
  no_pending_request: "保留中のリクエストが見つかりません！",
  news_feed: "ニュースフィード",
  user_info: "グループ情報",
  leave_project: "プロジェクトを退会",
  media_link_docs: "ファイル",
  search_chat: "チャットを検索",
  export_chat_group: "先月のチャットグループデータをエクスポート",
  request_complete_chat_history: "完全なチャット履歴をリクエスト",
  leave_chat_group: "チャットグループを退会",
  add_user_project: "ユーザーを追加",
  me: "私",
  max_open_one_to_one: "現在、最大2つの1対1チャットを下部と上部セクションで並行して開くことができます。合計で最大4つの1対1チャットが可能です。",
  are_you_sure_you_want_leave_chat: "本当にこのチャットグループを退会しますか？",
  create_group: "グループを作成",
  adding_members: "メンバーを追加中...",
  creating_the_chat: "チャットを作成中...",
  finishing_setup: "セットアップを完了中...",
  group_name: "グループ名",
  by: "作成者:",
  mandetory: "*必須",
  delteed: "がプロフィールを削除し、グループチャットを退会しました。",
  deleted_direct: "がプロフィールを削除し、チャットを退会しました。",
  unhidden_message: "プロジェクトの非表示を解除すると、Kjuupのすべてのメンバーが見つけることができます。",
  account_deleted: "アカウントが削除されました。",
  refuse_company: "本当に会社の招待を拒否しますか？",
  follow_additional: "追加のユーザーをフォロー",
  f_add: "Kjuupの追加ユーザーをフォローして、直接メッセージで利用できるようにします。",
  c_inv: "会社招待",
  invited_o_Company: "会社への参加に招待されました",
  refuse_companyX: "本当に会社のリクエストを拒否しますか？",
  a_Da: "アカウントが無効化されました。",
  has_deactivated: "がプロフィールを無効化しました。",
  reactive: "がプロフィールを再有効化しました。",
  juup_note: "*ユーザー名での登録はKjuup+メンバーのみ利用可能",
  username: "ユーザー名*",
  email_username: "メール/ユーザー名*",
  sPinText: "6桁のセキュリティPINを提供してください。このPINは、パスワードを忘れた場合に必要で、アカウントを確認するために必須です。",
  DeleteKjuupPlusText: "本当にプロフィールを削除しますか？プロフィールを削除すると、会社、プロジェクト、チャットへのすべての接続が削除されます。\n\nアカウント削除後48時間以内に、ユーザー名、パスワード、PINでサインインしてアカウントを再有効化できます。",
  reactive_text: "アカウントが削除されました。再有効化をクリックしてアカウントを再有効化してください。",
  rac: "再有効化",
  ac_ss: "アカウントが正常に再有効化されました。",
  not_valid_pin: "PINが無効",
  only_for_kjuup: "*ユーザー名とPINによるパスワードリセットはKjuup+メンバーのみ利用可能。",
  resetPIN: "PINをリセット",
  enter_current_pin: "現在のPINを入力してください",
  enter_new: "新しいPINを入力",
  pin_to_confirm: "確認するためにPINを提供してください。",
  change_username: "ユーザー名をリセット",
  pp_not_match: "パスワードと確認パスワードが一致しません",
  reactive_itself: "プロフィールを再有効化しました。",
  has_deactivated_itself: "プロフィールを無効化しました。",
  more_than_two: "現在、直接メッセージは2人のユーザーと並行してのみ可能です。",
  Chats: "直接メッセージ",
  only_in_mobileL: "ネイティブ動画は現在、モバイルアプリ経由でのみアップロードおよび投稿できます。YoutubeとVimeoの動画リンクを使用してください。",
  register_pin_text: "個人の6桁PINを選択してください。このPINはアカウントリセット機能を有効にするために必要です。",
  internal_project: "内部",
  external_projects: "外部",
  in_deacticted: "内部セクションが無効化されています。",
  create_article: "記事を作成",
  new_article_selection: "外部ニュースフィード用の記事を作成",
  new_article_selection_internal: "社内記事を作成",
  active_trans_title: "自動翻訳を有効にしますか？",
  active_trans: "有効にすると、受信したすべてのチャットメッセージが、選択したアプリの言語に翻訳されます。",
  disable_trans: "本当に自動翻訳を無効にしますか？",
  allow_access_chat: "完全なチャット履歴を表示",
  toggle_chat_history_on: "本当にユーザーに完全なチャット履歴を見せますか？",
  toggle_chat_history_off: "本当にユーザーにチャット参加時点からのチャット履歴のみを見せますか？",
  check_selected_settings: "選択したすべてのユーザーのチャット履歴設定を確認してください！",
  chat_from_start_have: "このグループに参加しました。チャット履歴が共有されました。",
  chat_from_start_has: "がこのグループに参加しました。チャット履歴が共有されました。",
  Address: "住所",
  read_by: "読者",
  deliver_to: "配信先",
  remaining: "残り",
  message_info: "メッセージ情報",
  request_to_join_only: "参加リクエスト",
  unfollow: "フォロー解除",
  company_username: "ユーザー名",
  month: ["1月", "2月", "3月", "4月", "5月", "6月", "7月", "8月", "9月", "10月", "11月", "12月"],
  remove_my_admin_right: "管理者権限を削除",
  makeEmp: "本当にユーザーから会社管理者権限を削除しますか？",
  remove_my_self: "本当にアカウントから会社管理者権限を削除しますか？",
  makeAdmin: "本当にユーザーに会社管理者権限を付与しますか？",
  remove_member: "メンバーを削除",
  remove_following_confirm: "本当に{name}をフォローリストから削除しますか？",
  remove_follower_confirm: "本当に{name}をフォロワーリストから削除しますか？削除すると、相手に通知されません。",
  do_you_really_want_to_remove: "本当に会社からユーザー名を削除しますか？",
  invite_all: "会社のすべてのメンバーを招待",
  invite_all_members: "すべてのメンバーを招待",
  mems: "他のすべてのメンバー",
  dep_loc: "部門/場所/チーム",
  depAdmin: "部門管理者",
  add_remove_admin: "会社管理者職を追加/削除",
  add_remove_dep_admin: "部門管理者職を追加/削除",
  remove_employees_dept: "から従業員を削除",
  want_to_join_dep: "ユーザー名が会社companynameの部門/場所/チームdepnameに参加したい。",
  you_invited: "会社companynameの部門/場所/チームdepnameへの参加に招待されました。",
  dep_remove: "本当にユーザーから部門または場所の管理者権限を削除しますか？",
  add_dep: "本当にユーザーに部門または場所の管理者権限を付与しますか？",
  my_self_dep_remove: "本当にアカウントから部門管理者権限を削除しますか？",
  member: "メンバー",
  admin: "管理者",
  remove_project_admin: "本当にプロジェクトからメンバーを削除しますか？",
  remove_my_self_project: "本当に管理者権限を削除しますか？",
  remove_member_admin_right: "本当にユーザーから管理者権限を削除しますか？",
  add_member_admin_right: "本当にユーザーに管理者権限を追加しますか？",
  add_remove_Poss: "管理者職を追加/削除",
  forward: "転送",
  edit: "編集",
  only_kjuup_plus_can: "Kjuup+会社のみが記事を投稿できます。",
  add_images: "画像を追加",
  request_confirmation: '保留中のプロジェクト招待',
  Activity: "アクティビティ",
  latest_messages: "最新のメッセージ",
  hours: "時間",
  minute: "分",
  seconds: "秒",
  days: "日",
  yesterday: "昨日",
  last_week: "先週",
  next_week: "来週",
  Last_month: "先月",
  All: "すべて",
  register_plus: "登録プラス",
  select_files: "ファイルを選択",
  monthsFullName: ["1月", "2月", "3月", "4月", "5月", "6月", "7月", "8月", "9月", "10月", "11月", "12月"],
  company_deploc_receivers_message: "Kjuupの会社company nameの部門への招待リンク。Kjuupに登録して会社company nameに参加するにはリンクをクリックしてください。",
  no_news: "ニュースがありません",
  reminder: "リマインダー",
  np_reminder: "ToDoがありません",
  move_to_reminder: "ToDoに移動",
  remove_reminder: "本当にこのメッセージをToDoリストから削除しますか？",
  remove_all_reminder: "すべてのToDoを削除",
  remove_all_confirm: "本当にすべてのメッセージをToDoリストから削除しますか？",
  remove_from_reminder: "リマインダーから削除",
  prevent_email: "メールをユーザー名として使用できません。",
  allow_noti: "通知を許可してください。",
  join_cap: "参加",
  pass_minimum: "**パスワードには12文字が必要です（小文字、大文字、数字、特殊文字を含む）。",
  pass_error: "パスワード要件を確認してください",
  people_that_like_article: "記事にいいねした人。",
  people_who_like_article: "あなたの記事にいいねした人。",
  message_delete: "このメッセージは削除されました。",
  message_edited: "編集済み",
  edit_message: "メッセージを編集",
  edit_window_expired: "メッセージは送信後10分以内のみ編集できます。",
  message_edit_save: "保存",
  copy: "コピー",
  bookmark: "ブックマーク",
  add_reaction: "リアクションを追加",
  delete_message: "メッセージを削除",
  more_options: "その他",
  info: "情報",
  link_invite: "リンク経由で招待",
  ll_nkk: "Kjuupに招待",
  selected: "選択済み",
  is_active: "アクティブ",
  inactive: "非アクティブ",
  last_online: "最終オンライン {{when}}",
  remove_user_l: "削除",
  link_expire: "生成された各リンクは72時間有効です。",
  company_language: "会社の言語",
  company_language_info: "言語選択は、会社に関するすべてのメール確認に使用されます。",
  s_image: "画像",
  m_image: "画像",
  removeMsg: "タップして削除",
  block: 'ブロック',
  unblock: 'ブロック解除',
  blocks: '本当にこのユーザーをブロックしますか？',
  unblocks: '本当にこのユーザーのブロックを解除しますか？',
  bolcked_click_un_block: 'この連絡先をブロックしました。ブロックを解除するにはここをクリックしてください。',
  you_have_unblocked: 'この連絡先のブロックを解除しました。',
  you_have_blocked: 'この連絡先をブロックしました。',
  unblock_to_send: 'メッセージを送信するにはユーザーのブロックを解除してください。',
  pilot_text: "建設トピック専用AI",
  startup_screen_label: "起動画面",
  startup_screen_info: "Kjuup起動時に開く画面を選択してください。",
  startup_screen_feed: "Home",
  startup_screen_messages: "メッセージ",
  startup_screen_saved: "起動画面を更新しました",
email_on: "メール通知チャット",
  email_on_grp: "メール通知",
  article_email_on: "Email notification articles",
  article_email_info: "If you enable email notifications for internal articles, you will receive an email when a new internal article is published in your company and department.",
  info_email_room: "このプロジェクトのメール通知を有効または無効にします。このオプションは、個人設定で「メール通知チャット」が有効な場合のみ利用可能です。",
  todo_notification_info: "新しいToDoが割り当てられるたびに通知されます。",
  info_val: "新しいチャットメッセージが短時間で読まれない場合、メールが届きます。各プロジェクトの設定やチャットグループ情報で、特定のプロジェクトやチャットについてこれをオフにできます。",
  email_groups: "このチャットのメール通知を有効または無効にします。このオプションは、個人設定およびプロジェクト設定で「メール通知チャット」が有効な場合のみ利用可能です。",
  add_update_email: "メールを追加/更新",
  text_to_verifiy: "「メール通知チャット」オプションは、ファイルに確認済みメールアドレスがある場合のみ有効にできます。",
  stored_email: "保存されたメール: ",
  verify_email: "確認保留中！",
  join_call: "参加",
  call_is_started: "通話が開始されました",
  start_chat: "直接チャットを開始しますか？",
  project_rooms: "プロジェクト",
  download_selected: "ダウンロード",
  add_employee_confirm: '本当にこのユーザーを会社に追加しますか？',
  invalid_deeplink: "無効なdeeplink URL。必要なパラメータが不足しています。",
  deeplink_error: "deeplinkを処理できません。後でもう一度お試しください。",
  reply: "返信",
  reply_enter: "返信を入力...",
  reply_sent_successfully: "返信が正常に送信されました",
  reply_failed: "返信の送信に失敗しました",
  reply_failed_generic: "返信の送信に失敗しました。もう一度お試しください。",
  replying_to_message: "メッセージに返信中",
  cancel_reply: "返信をキャンセル",
  voice_message: "音声メッセージ",
  send: "送信",
  cancel: "キャンセル",
  type_your_reply: "返信を入力...",
  suggested_replies: "提案された返信",
  suggestions_error: "提案の読み込みに失敗しました",
  positive_suggestion_placeholder: "Positive",
  neutral_suggestion_placeholder: "Neutral",
  negative_suggestion_placeholder: "Negative",
  lazy_media_image: "Image — Click to load",
  lazy_media_audio: "Voice message — Click to load",
  lazy_media_doc: "Document — Click to load",
  lazy_media_video: "Video — Click to load",
  suggestion_loading_message: "少々お待ちください。テキストを個別に準備しています。",
  loading_chat_message: "チャットを読み込み中...",
  extracting_message: "メッセージを抽出中...",
  create_todo: "ToDoを作成",
  create_todo_confirmation: "このメッセージからToDoを作成しますか？",
  select_project_required: "プロジェクト/グループを選択してください",
  only_assigned_can_change_status: "割り当てられたユーザーのみがステータスを変更できます",
  todo_summary: "概要",
  todo_summary_placeholder: "todo概要を入力...",
  todo_date: "日付",
  todo_time: "時間",
  todo_date_hint: "元のメッセージの日付/時間を使用するには空のままにします",
  todo_created_success: "ToDoが正常に作成されました",
  todo_creation_failed: "ToDoの作成に失敗しました",
  create: "作成",
  image: "画像",
  images: "画像",
  remove_all_images: "すべての画像を削除",
  remove_image: "画像を削除",
  remove_document: "ドキュメントを削除",
  remove_recording: "録音を削除",
  play_recording: "録音を再生",
  upload_image: "画像をアップロード",
  upload_document: "ドキュメントをアップロード",
  record_audio: "音声を録音",
  stop_recording: "録音を停止",
  stop_recording_text: "録音を停止",
  please_remove_current_attachment: "現在の添付ファイルを削除してください",
  please_upload_image_file: "有効な画像ファイルをアップロードしてください",
  please_upload_valid_document: "有効なドキュメントファイルをアップロードしてください",
  searching_messages: "メッセージを検索中...",
  loading_more: "さらに読み込み中...",
  loading_more_users: "さらにユーザーを読み込み中...",
  load_more_users: "さらにユーザーを読み込む",
  no_more_users_to_load: "読み込むユーザーがありません",
  no_messages_found: "メッセージが見つかりません",
  try_different_keyword: "別のキーワードを試すか、スペルを確認してください。",
  search_messages: "メッセージ、チャットグループ、プロジェクト、ユーザーを検索...",
  todo: "ToDo",
  np_todo: "ToDoがありません",
  move_to_todo: "ToDoとして保存",
  remove_todo: "本当にToDoを削除しますか？",
  remove_all_todo: "すべてのToDoを削除",
  remove_all_todo_confirm: "本当にすべてのToDoを削除しますか？",
  add_to_todo: "ToDoに追加",
  remove_from_todo: "ToDoから削除",
  confirm: "確認",
  ok: "OK",
  read_more: "続きを読む",
  show_less: "折りたたむ",
  show_more: "もっと見る",
  audio: "音声",
  video: "動画",
  notification_schedule: "通知スケジュール",
  notification_schedule_desc: "選択した時間帯のみプッシュおよびメール通知を受信します。それ以外の時間は一時停止されます。",
  learn_more: "詳細を見る",
  allow_notifications: "通知を許可:",
  every_day: "毎日",
  weekdays: "平日（月曜日から金曜日）",
  custom: "カスタム",
  monday: "月曜日",
  tuesday: "火曜日",
  wednesday: "水曜日",
  thursday: "木曜日",
  friday: "金曜日",
  saturday: "土曜日",
  sunday: "日曜日",
  to: "まで",
  notification_settings: "通知",
  notification_settings_saved: "通知設定が正常に保存されました",
  notification_settings_error: "通知設定の保存に失敗しました",
  unavailability_note: "不在通知",
  unavailability_description: "不在メモを設定します。有効な間、メモはすべてのチャットで他のユーザーに表示され、通知は一時停止されます。",
  unavailability_start_date: "開始日",
  unavailability_end_date: "終了日",
  unavailability_message: "メッセージ",
  unavailability_message_hint: "復帰日のプレースホルダーとして {endDate} を使用してください。",
  unavailability_replacement: "代理連絡先",
  unavailability_replacement_placeholder: "緊急のリクエスト用のユーザーIDを入力",
  unavailability_replacement_current: "現在の代理",
  unavailability_replacement_hint: "設定すると、緊急の件でこの方に連絡するためのリンクが不在通知に表示されます。",
  unavailability_replacement_none: "代理なし（任意）",
  unavailability_contact_urgent: "緊急のリクエストはこちらに連絡",
  unavailability_default_message: "現在オフィスを不在にしており、Kjuupにアクセスできません。{endDate}から再び対応可能となり、その際にご連絡いたします。",
  unavailability_save: "保存",
  unavailability_deactivate: "無効にする",
  unavailability_active_until: "有効期限",
  unavailability_saved: "不在通知が保存されました",
  unavailability_save_error: "不在通知の保存に失敗しました",
  unavailability_deactivated: "不在通知が無効になりました",
  unavailability_end_date_required: "終了日は必須です",
  start_time_before_end_time: "開始時刻は終了時刻より前である必要があります",
  loading: "読み込み中",
  disabled: "無効",
  enable: "有効にする",
  disable: "無効にする",
  forwarded: "転送済み",
  message_forwarded: "メッセージが転送されました！",
  schedule_article_post: "記事投稿をスケジュール",
  date: "日付",
  time: "時間",
  scheduled_for_publication: "公開予定",
  article_will_be_published_on: "記事は以下に公開されます:",
  reset_selection: "選択をリセット",
  continue: "続ける",
  cancel: "キャンセル",
  error_loading_members: "メンバーの読み込みエラー",
  please_fill_all_fields: "すべての項目を入力してください",
  invalid_email: "無効なメールアドレス",
  member_added_successfully: "メンバーが正常に追加されました",
  error_onboarding_user: "ユーザーの追加エラー",
  error_creating_chat: "チャットの作成エラー",
  error_creating_group: "グループの作成エラー",
  new_group: "新しいグループ",
  please_select_or_enter_group_name: "グループを選択するか、グループ名を入力してください",
  please_select_or_enter_room_name: "プロジェクトを選択するか、プロジェクト名を入力してください",
  error_creating_room: "プロジェクトの作成エラー",
  error_opening_chat: "チャットの開始エラー",
  privacy_modal_text: "チャットにプロジェクトマネージャーに関連する専門的なコンテンツが含まれていない場合のみ「プライベート」を選択してください。",
  not_private: "プライベートではない",
  private: "プライベート",
  error_loading_groups: "グループの読み込みエラー",
  automatic_chat_export: "自動チャットエクスポート",
  automatic_chat_export_info: "有効化後、チャット履歴が毎月指定されたメールアドレスに自動送信されます。",
  automatic_chat_export_no_email: "自動チャットエクスポートを有効にするには、まずメールアドレスを追加する必要があります。メールアドレスは個人設定で追加できます。",
  enter_email: "メールを入力",
  update: "更新",
  confirm: "確認",
  export_to_email: "エクスポートは次のメールに送信されます。",
  start_chat_button: "新しいメッセージ",
  matching_existing_chats: "既存のチャットと一致",
  subject: "件名",
  add_subject: "件名を追加",
  chat_subject: "チャット件名:",
  set_project_room: "プロジェクトを設定",
  matching_existing_project_rooms: "既存のプロジェクトと一致",
  name_project_room: "プロジェクト名",
  professional_or_private: "プロフェッショナルまたはプライベート",
  professional: "プロフェッショナル",
  privacy_modal_text_updated: "チャットにプロジェクトマネージャーに関連する専門的なコンテンツが含まれていない場合のみ「プライベート」を選択してください。プライベートチャットはプロジェクトマネージャーには表示されません。",
  create_internal_chat: "外部 - または内部チャット？",
  internal_chat_description: "会社の従業員のみが内部チャットに追加できます。",
  yes: "はい",
  no: "いいえ",
  chat_is_being_created: "チャットを作成中...",
  discard_article_confirm: "この記事への変更を破棄してもよろしいですか？",
  please_enter_article_title: "まず記事タイトルを入力してください。",
  please_add_mandatory_fields: "すべての必須項目を追加してください",
  product_label: "製品:",
  no_companies_found: "会社が見つかりません",
  visible_to_all_followers: "すべてのKjuupメンバーに表示",
  only_visible_to_employees: "従業員にのみ表示",
  something_went_wrong: "問題が発生しました。もう一度お試しください",
  please_select_department: "部門/場所を選択してください",
  schedule: "スケジュール",
  please_select_future_date_time: "記事をスケジュールするために、将来の日付と時刻を選択してください。",
  please_select_different_date_time: "記事をスケジュールするために、別の日付または時刻を選択してください。",
  please_select_later_time: "今日の現在時刻より後の時刻を選択してください。",
  unpin_article: "記事のピン留めを解除",
  pin_article: "記事をピン留め",
  and: "と",
  others: "その他",
  at: "で",
  mute: "ミュート",
  unmute: "ミュート解除",
  chat_muted_successfully: "チャットが正常にミュートされました",
  chat_unmuted_successfully: "チャットのミュートが正常に解除されました",
  mute_chat_confirm: "本当にこのチャットをミュートしますか？新しいメッセージの通知を受信しなくなります。",
  unmute_chat_confirm: "本当にこのチャットのミュートを解除しますか？新しいメッセージの通知を再度受信します。",
  please_select_group_to_forward: "メッセージを転送するグループを選択してください",
  record_not_found: "レコードが見つかりません！",
  please_select_position: "役職を選択してください",
  delete_article_confirm: "本当にこの記事を削除しますか？",
  delete_company_service_confirm: "本当に会社サービスを削除しますか？",
  block_translation_confirm: "本当に会社のすべてのメンバーのプロジェクトでの自動翻訳をブロックしますか",
  unblock_translation_confirm: "本当に会社のすべてのメンバーのプロジェクトでの自動翻訳のブロックを解除しますか",
  please_select_file: "アップロードするファイルを選択してください",
  role_in_building_industry: "建設業界での役割*",
  invalid_email_address: "無効なメールアドレス",
  please_enter_password: "パスワードを入力してください",
  password_change_email_sent: "Kjuupのメールアドレスにメールを送信しました。メール内の確認リンクをクリックして、新しいパスワードを確認してください。",
  please_enter_username: "ユーザー名を入力してください",
  username_same_as_before: "ユーザー名は以前と同じにできません",
  profile_deleted_successfully: "プロフィールが正常に削除されました",
  hardware_requirements: "ハードウェア要件",
  hardware_requirements_list: "• 4GB RAM<br/>• CPU速度 最小2GHz<br/>• Windows 7以上 / すべてのmacOSバージョン",
  submitting: "送信中...",
  signing_in: "サインイン中...",
  please_enter_service_name: "サービス名を入力してください",
  something_went_wrong_error: "ああ！問題が発生しました...",
  something_went_wrong_try_again: "申し訳ございません。問題が発生しました。もう一度お試しください",
  position_label: "役職:",
  loading_room: "プロジェクトを読み込み中...",
  navigating_to_room: "プロジェクトに移動中",
  loading_chat: "チャットを読み込み中...",
  translate: "翻訳",
  show_original: "原文を表示",
  saving: "保存中...",
  language_selection_info: "言語選択は、会社に関連するすべてのメール確認に使用されます。",
  nav_call: "通話",
  nav_home: "ホーム",
  nav_messages: "メッセージ",
  nav_todo: "ToDo（複数）",
  nav_rooms: "プロジェクト",
  nav_all_rooms: "すべてのプロジェクト",
  pinned_rooms_max: "最大10プロジェクトまでピン留めできます。",
  pinned_room_unpin: "ピン留めを外す",
  pinned_rooms_drop: "クイック選択のため、プロジェクトをここにドラッグしてください",
  nav_profile: "プロフィール",
  nav_company: "会社",
  nav_company_documents: "書類",
  nav_logout: "ログアウト",
  add_member_title: "メンバーを追加",
  continue_btn: "続ける",
  search_placeholder: "検索",
  no_members_found: "メンバーが見つかりません",
  no_groups_found: "グループが見つかりません",
  no_rooms_found: "プロジェクトが見つかりません",
  search_users_tab: "ユーザー",
  search_documents_tab: "ドキュメント",
  company_documents: "Company documents",
  company_documents_empty: "No documents available.",
  no_media_available: "ファイルがありません",
  no_documents_available: "No documents",
  searching_users: "ユーザーを検索中...",
  no_users_found: "ユーザーが見つかりません",
  search_emails_tab: "メール",
  searching_emails: "メールを検索中...",
  no_emails_found: "メールが見つかりません",
  search_email_addresses_tab: "E-Mail Addresses",
  search_email_content_tab: "E-Mail Content",
  searching_email_content: "Searching email content...",
  no_email_content_found: "No email content found",
  search_email_attachments_tab: "E-Mail Attachments",
  searching_email_attachments: "Searching attachments...",
  no_email_attachments_found: "No attachment matches found",
  email_attachments_label: "Attachments",  searching_email_addresses: "Searching addresses...",
  no_email_addresses_found: "No address matches found",
  email_subject_label: "Subject",
  email_body_label: "Body",
  email_address_received: "Received",
  email_address_sent: "Sent",
  unnamed_group: "名前のないグループ",
  unnamed_room: "名前のないプロジェクト",
  all_members: "すべて",
  room_label: "プロジェクト:",
  subject_label: "件名:",
  no_members: "メンバーなし",
  creating_structure: "構造を作成中",
  opening_chat: "チャットを開いています",
  please_wait: "お待ちください...",
  loading_todo: "ToDoを読み込み中...",
  task_updated: "タスクが更新されました",
  error_updating_task: "タスクの更新エラー",
  task_deleted: "タスクが削除されました",
  error_deleting_task: "タスクの削除エラー",
  delete_task_confirm: "本当にこのタスクを削除しますか？",
  description_label: "説明",
  description_placeholder: "説明を入力...",
  date_time_label: "日付と時刻",
  save_hint: "Ctrl+Enterで保存、Escでキャンセル",
  edit_label: "編集",
  delete_label: "削除",
  todo_list_title: "ToDo（複数）",
  tasks_count: "タスク",
  search_placeholder_todo: "検索...",
  select_task_to_open_chat: "チャットを開くタスクを選択",
  today: "今日",
  yesterday: "昨日",
  time_suffix: "",
  from_chat: "ソースToDo",
  assigned_to: "割り当て先",
  assign_users: "ユーザーを割り当て",
  no_users_assigned: "割り当てられたユーザーなし",
  assign: "割り当て",
  assign_to: "割り当て先...",
  navigate_to_chat: "チャットに移動",
  navigate_to_email: "メールを開く",
  show_original_message: "ソースを表示",
  hide_original_message: "ソースを非表示",
  status_pending: "保留中",
  status_in_progress: "進行中",
  status_completed: "完了",
  show: "表示",
  close: "閉じる",
  // Log translations
  status_confirmed: "[確認済み]",
  log_todo_created: "ToDo [作成されました]",
  log_todo_confirmed: "ToDo [確認されました]",
  log_todo_deleted: "ToDo [削除されました]",
  log_todo_updated: "ToDo [更新されました]",
  log_description_updated: "[説明が更新されました]",
  log_deadline_updated: "[期限が更新されました]",
  log_assigned_to: "[割り当て先] {name}",
  log_unassigned_from: "[割り当て解除] {name}",
  log_assignment_added: "[割り当てが追加されました]: {name}",
  log_assignment_removed: "[割り当てが削除されました]: {name}",
  log_status_updated: "[ステータスが] {from} [から] {to} [に変更されました]",
  log_status_changed: "[ステータスが変更されました]",
  log_status_changed_to: "[ステータスが変更されました] {status}",
  log_changed_status_to: "[ステータスを変更しました]:",
  log_for_user: "[ユーザー]:",
  log_user_updated_status: "[ユーザーがToDoのステータスを更新しました]",
  log_changed_date_to: "[日付を変更しました]:",
  log_changed_description_to: "[説明を変更しました]:",
  log_moved_to: "[移動先] {status}",
  todo_status_updated_from: "[から]",
  todo_status_updated_to: "[へ]",
  filter_pending: "保留中",
  filter_confirmed: "確認済み",
  filter_assigned_to_me: "マイタスク",
  filter_assigned_by_me: "委任済み",
  todo_project_label: "プロジェクト:",
  assigned_users: "割り当てられたユーザー:",
  todo_chat_label: "チャット:",
  history: "履歴",
  todo_assigned_by: "割り当て者:",
  todo_assigned_push: "割り当てられたToDo:",
  todo_assigned_push_empty: "新しいToDoが割り当てられました。",
  search_groups: "グループ",
  search_chat_groups: "チャットグループ",
  search_project_room: "プロジェクト",
  search_messages_tab: "メッセージ",
  searching_groups: "グループを検索中...",
  searching_rooms: "プロジェクトを検索中...",
  no_groups_found: "グループが見つかりません",
  no_rooms_found: "プロジェクトが見つかりません",
  create_poll: "投票",
  poll_question_label: "質問",
  poll_question_placeholder: "質問を入力",
  poll_options_label: "選択肢",
  poll_option: "選択肢",
  poll_add_option: "選択肢を追加",
  poll_allow_multiple: "複数選択を許可",
  poll_multiple_allowed: "1つまたは複数選択",
  poll_select_option: "1つ選択",
  poll_view_votes: "投票を見る",
  poll_vote_singular: "票",
  poll_vote_plural: "票",
  poll_votes: "投票結果",
  poll_no_votes_yet: "まだ投票はありません",
  transcript_step_processing: "文字起こし中...",
  ai_transcript_tab: "AI文字起こし",
  ai_transcript_info: "2026年3月9日以降に作成された音声メッセージのみ利用可能です。",
  transcript_more: "...もっと見る",
  transcript_less: "...閉じる",
  ki_transcript_voice_message: "KI-音声メッセージの文字起こし",
  ki_image_analysis: "AI画像解析",
  type_message: "メッセージを入力",
  email_tab_messages: "メッセージ",
  email_tab_email: "メール",
  email_tab_messages_and_email: "Messages & E-Mail",
  email_tab_email_details: "E-Mail Details",
  email_accounts: "メールアカウント",
  email_connect_gmail: "Gmailを接続",
  email_connect_outlook: "Outlookを接続",
  email_no_accounts: "接続されたメールアカウントがありません",
  email_no_accounts_hint: "プロフィール設定でメールアカウントを接続してください",
  email_no_messages: "メールがありません",
  email_from: "差出人",
  email_to: "宛先",
  email_subject: "件名",
  email_disconnect: "接続を解除",
  email_disconnect_confirm: "このメールアカウントの接続を解除してもよろしいですか？同期されたすべてのメールが削除されます。",
  email_account_disconnected: "メールアカウントの接続を解除しました",
  email_account_disconnect_failed: "アカウントの接続解除に失敗しました",
  email_connecting: "接続中...",
  email_account_connected: "アカウントが正常に接続されました",
  email_signature: "Signature",
  email_signature_placeholder: "Enter your email signature...",
  email_signature_save: "Save",
  email_signature_saved: "Saved",
  email_go_to_settings: "設定へ",
  email_date: "日付",
  email_reply: "返信",
  email_forward: "転送",
  email_copy_text: "テキストをコピー",
  email_text_copied: "コピーしました！",
  email_text_copy_failed: "テキストをコピーできませんでした。",
  email_delete: "削除",
  email_not_spam: "迷惑メールではない",
  email_not_spam_success: "メールを受信トレイに移動しました。",
  email_not_spam_failed: "受信トレイへの移動に失敗しました。",
  email_delete_confirm: "このメールを削除してもよろしいですか？",
  email_delete_from_folder: "{folder}から削除してもよろしいですか？",
  email_delete_permanent_from_folder:
    "{folder}から完全に削除してもよろしいですか？この操作は取り消せません。",
  email_save_draft_confirm: "このメールを下書きとして保存しますか？",
  email_save_draft: "下書き保存",
  email_discard: "破棄",
  email_back_to_compose: "作成に戻る",
  email_draft_saved: "下書きを保存しました。",
  email_draft_save_failed: "下書きの保存に失敗しました。",
  email_loading: "メールを読み込み中...",
  email_archived: "Archived",
  email_mark_spam: "Mark as spam",
  email_marked_spam: "Marked as spam",
  email_group_today: "Today",
  email_group_yesterday: "Yesterday",
  email_group_this_week: "This week",
  email_group_earlier: "Earlier",
  email_search: "Search",
  email_search_placeholder: "Search mail",
  email_no_results: "No matching messages",
  email_clear_search: "Clear search",
  email_star: "Star",
  email_unstar: "Unstar",
  email_starred: "Starred",
  email_folder_starred: "Starred",
  email_select: "選択",
  email_attachment_singular: "添付ファイル",
  email_attachment_plural: "添付ファイル",
  email_back: "戻る",
  email_download: "ダウンロード",
  email_close: "閉じる",
  email_preview: "プレビュー",
  email_preview_not_available: "プレビューは利用できません",
  email_preview_failed: "プレビューは利用できません",
  select_attachments: "添付ファイルを選択",
  email_loading_preview: "プレビューを読み込み中...",
  email_mark_unread_failed: "件のメールを未読にできませんでした。",
  email_delete_failed: "件のメールを削除できませんでした。",
  filter_all: "すべて",
  filter_email: "E-Mail",
  filter_kjuup_messages: "Kjuup",
  filter_direct_messages: "直接メッセージ",
  my_notes: "My Space",
  filter_internal_groups: "内部グループチャット",
  filter_external_groups: "外部グループチャット",
  filter_group_chats: "グループチャット",
  filter_groups_internal: "内部",
  filter_groups_external: "外部",
  filter_unread_only: "未読のみ",
  room_daily_briefing_info: "有効にすると、個人設定で指定した時刻に24時間ごとにこのプロジェクトのレポートが生成されます。ただし、その期間にアクティビティがあった場合のみです。",
  email_select_all: "すべて選択",
  email_deselect_all: "すべて選択解除",
  email_reply_all: "全員に返信",
  email_reply_placeholder: "返信を入力...",
  email_forward_placeholder: "メッセージを追加...",
  email_edit_draft: "下書きを編集",
  email_attach: "添付",
  email_attachment_from_original: "元のメッセージから",
  email_remove: "削除",
  email_drop_files: "ファイルをドロップして添付",
  email_loading_attachments: "添付ファイルを読み込み中...",
  email_archive: "アーカイブ",
  mark_unread: "未読にする",
  mark_read: "既読にする",
  email_all_accounts: "すべてのアカウント",
  email_error: "エラー",
  email_delete_email_failed: "メールの削除に失敗しました。",
  enter_url: "URLを入力",

  // ─── Kjuup subscription ───────────────────────────────────────────
  kjuup_io: 'Kjuup.io',
  kjuup_io_manage_subscription: 'Manage your subscription',
  kjuup_io_subscribe_now: '今すぐ登録',
  kjuup_io_hero_subtitle: 'Upgrade to unlock premium features and get more out of every project.',
  kjuup_io_trial_badge: '1か月無料トライアル',
  kjuup_io_trial_title: 'Unlock Kjuup.io Premium',
  kjuup_io_trial_subtitle: 'Connect your email, receive AI-powered smart replies and synchronize your tasks with your calendar.',
  kjuup_io_trial_no_payment: 'No payment today.',
  kjuup_io_trial_trust: '今日のお支払いはありません。有料サブスクリプション開始前にクレジットカード情報は求められません。',
  kjuup_io_after_trial_monthly: 'After trial: {price}/month',
  kjuup_io_after_trial_yearly: 'After trial: {price}/year',
  kjuup_io_price_per_month: '{price}/month',
  kjuup_io_price_per_year: '{price}/year',
  kjuup_io_start_free_trial: 'Start free now � no risk',
  kjuup_io_trial_footnote: 'No payment today. Then {price}. Cancel anytime.',
  kjuup_io_feature_email: 'すべてのメールアカウントをKjuupで直接管理',
  kjuup_io_feature_assign: 'Automatically assign emails and attachments to projects',
  kjuup_io_feature_ai: 'AIが返信を作成 – あなたは確認するだけ',
  kjuup_io_feature_tasks: 'タスクとカレンダーを常に自動で最新に',
  kjuup_io_choose_plan: 'プランを選択',
  kjuup_io_plan_monthly: '月額',
  kjuup_io_plan_yearly: '年額',
  kjuup_io_plan_monthly_desc: 'Billed monthly · cancel anytime',
  kjuup_io_plan_yearly_desc: 'Save {pct}% with annual booking',
  kjuup_io_save_badge: 'SAVE {pct}%',
  kjuup_io_per_month_annual: '{price} / month · Save {pct}% with annual booking',
  kjuup_io_subscribe: 'Subscribe',
  kjuup_io_secured_stripe: 'Stripeで安全に決済 · いつでも解約可能',
  kjuup_io_your_subscription: 'YOUR SUBSCRIPTION',
  kjuup_io_status_active: 'ACTIVE',
  kjuup_io_status_cancels_soon: 'CANCELS SOON',
  kjuup_io_status_switch_scheduled: 'SWITCH SCHEDULED',
  kjuup_io_label_plan: 'Plan',
  kjuup_io_label_price: 'Price',
  kjuup_io_label_status: 'Status',
  kjuup_io_label_renews: 'Renews on',
  kjuup_io_label_access_until: 'Access until',
  kjuup_io_switching_to: 'Switching to {plan} on {date}',
  kjuup_io_cancel_pending_note: 'Your subscription is set to cancel and won\'t renew. You keep access until the date above.',
  kjuup_io_resume: 'Resume subscription',
  kjuup_io_switch_to_plan: 'Switch to {plan} plan',
  kjuup_io_undo_switch: 'Undo scheduled change',
  kjuup_io_cancel_subscription: 'Cancel subscription',
  kjuup_io_switch_modal_title: 'Switch to {plan} plan?',
  kjuup_io_billed_yearly: 'Billed yearly',
  kjuup_io_billed_monthly: 'Billed monthly',
  kjuup_io_switch_modal_note: 'Starts on {date}, when your current {plan} plan ends. No charge today — you keep your current plan until then.',
  kjuup_io_confirm_switch: 'Confirm switch',
  kjuup_io_not_now: 'Not now',
  kjuup_io_cancel_modal_title: 'Cancel subscription?',
  kjuup_io_cancel_modal_note: 'You\'ll keep access to Kjuup.io until the end of your current billing period. After that it won\'t renew.',
  kjuup_io_cancel_modal_note_with_date: 'You\'ll keep access to Kjuup.io until the end of your current billing period ({date}). After that it won\'t renew.',
  kjuup_io_cancel_plan: 'Cancel plan',
  kjuup_io_keep_subscription: 'Keep my subscription',
  kjuup_io_toast_payment_failed: 'Payment failed',
  kjuup_io_toast_activating: '支払いを確認しました。サブスクリプションを有効化しています…',
  kjuup_io_toast_activating_soon: '支払いを確認しました。まもなく有効になります。',
  kjuup_io_toast_cancel_period: 'Your subscription will cancel at the end of the period',
  kjuup_io_toast_cancel_fail: 'Unable to cancel subscription',
  kjuup_io_toast_switch_scheduled: 'You\'ll move to the {plan} plan when your current period ends',
  kjuup_io_toast_switch_fail: 'Unable to switch plan',
  kjuup_io_toast_resumed: 'Your subscription will keep renewing',
  kjuup_io_toast_resume_fail: 'Unable to resume subscription',
  kjuup_io_toast_undo: 'Scheduled plan change canceled',
  kjuup_io_toast_undo_fail: 'Unable to cancel the scheduled change',
  kjuup_io_email_locked_body: 'Email is part of Kjuup.io. Activate a plan to use the Email tab.',
  kjuup_io_connect_email: 'Connect email with Kjuup.io',
  kjuup_io_activate_to_connect_email: 'Activate Kjuup.io to connect email accounts',

  kjuup_io_trial_no_card: 'No credit card details are requested before your paid subscription starts.',
  kjuup_io_status_trialing: 'TRIAL',
  kjuup_io_trial_days_left: '{days} days left in your free trial',
  kjuup_io_trial_left_hours: '残り{count}時間',
  kjuup_io_trial_left_hour: '残り1時間',
  kjuup_io_trial_left_minutes: '残り{count}分',
  kjuup_io_trial_left_minute: '残り1分',
  kjuup_io_trial_left_seconds: '残り{count}秒',
  kjuup_io_trial_left_second: '残り1秒',
  kjuup_io_trial_ending_now: 'トライアルが終了します…',
  kjuup_io_request_timeout: '接続がタイムアウトしました。もう一度お試しください。',
  kjuup_io_info_days_free: '{days}日間完全無料 – トライアル後にのみサブスクリプションが開始します。',
  kjuup_io_discount_total: '割引：{percent}%',
  kjuup_io_discount_company: '{company}：{percent}%',
  kjuup_io_discount_personal: '個人：{percent}%',
  kjuup_io_trial_ends_tomorrow: 'Your free trial ends tomorrow',
  kjuup_io_trial_ends_today: 'Your free trial ends today',
  kjuup_io_banner_dismiss: '閉じる',
  kjuup_io_billing_after_trial: 'You\'ll be charged after your trial ends on {date}.',
  kjuup_io_trial_ended_title: '無料トライアルが終了しました',
  kjuup_io_trial_ended_body: 'メールやその他のプレミアム機能を引き続き利用するには、Kjuup.io にご登録ください。',
  kjuup_io_subscribe_to_continue: 'Subscribe now to continue',
  kjuup_io_trial_active_title: 'You\'re on a free trial',
  kjuup_io_trial_active_subtitle: 'Choose a plan and subscribe — billing starts when your trial ends.',
  kjuup_io_toast_trial_started: '無料トライアルが始まりました',
  kjuup_io_toast_trial_fail: '無料トライアルを開始できませんでした',
  kjuup_io_trial_try_month: 'Try Kjuup.io free for one month.',
  kjuup_io_per_month: 'per month',
  kjuup_io_price_month_line: '{price} / 月',
  kjuup_io_save_amount_year: '年間 {price} お得',
  kjuup_io_billed_annually_amount: '年額 {price}',
  kjuup_io_save_yearly: 'Save {pct}% with yearly billing.',
  kjuup_io_savings_pct: '{pct}% savings',
  kjuup_io_features_title: 'できること:',
  kjuup_io_info_one_month_free: 'One month free',
  kjuup_io_info_plan_after_trial: 'Your selected subscription starts after the trial.',
  kjuup_io_info_cancel_trial: 'Cancel anytime during the trial.',
  kjuup_io_info_no_card: 'クレジットカード不要 – 支払い情報なしですぐに開始。',
  kjuup_io_info_cancel_anytime: 'いつでも解約可能 – 拘束なし、リスクなし。',
  kjuup_io_cta_plan_begins: 'Your selected plan begins after the free trial.',
  kjuup_io_billing_period_aria: '請求期間',
  kjuup_io_subscription_info_title: 'Subscription information',
  kjuup_io_first_payment_on: 'First payment on {date}.',
  kjuup_io_renews_on: 'Renews on {date}.',
  kjuup_io_toast_card_saved: '支払い方法を保存しました。トライアル終了時に請求されます。',
  calendar_sync_info: 'すべての Kjuup ToDo をカレンダーと自動同期します。',
  calendar_no_accounts: 'カレンダーがまだ接続されていません。',
  article_new_badge: '新着',
  article_new_posts: '新着投稿 {0} 件',
  documents: 'ドキュメント',
  add_documents: 'ドキュメントを追加',
  no_preview_available: 'プレビューできません',
  no_preview_hint: 'このファイル形式はプレビューできませんが、送信は可能です。',
  max_documents_reached: '一度に添付できるドキュメントは10件までです。',
  open_file: 'ファイルを開く',
  twofa_title: '二要素認証',
  twofa_method_totp: '認証アプリ',
  twofa_method_sms: 'SMS',
  twofa_method_email: 'メール',
  twofa_enter_app: '認証アプリの6桁のコードを入力してください。',
  twofa_enter_sms: 'SMSで送信した6桁のコードを入力してください。',
  twofa_enter_email: 'メールで送信した6桁のコードを入力してください。',
  twofa_resend: 'コードを再送信',
  twofa_try_another: '別の方法を試す',
  twofa_remember_device: 'この端末では30日間確認しない',
  twofa_sent: 'コードを送信しました。',
  twofa_invalid_code: 'コードが正しくありません。もう一度お試しください。',
  twofa_something_wrong: '問題が発生しました。もう一度お試しください。',
  twofa_method_unavailable: 'その確認方法は利用できません。',
  twofa_on_desc: '二要素認証はオンです。サインインのたびにコードが必要です。',
  twofa_off_desc: 'パスワードの後に2つ目の手順を追加します。認証アプリが最も安全です。',
  twofa_methods: '方法',
  twofa_on: 'オン',
  twofa_add: '追加',
  twofa_default_method: 'デフォルトの方法',
  twofa_default: 'デフォルト',
  twofa_turn_off: 'オフにする',
  twofa_disable_hint: '二要素認証をオフにするには、パスワードと現在のコードを入力してください。',
  twofa_disable_need: 'パスワードと確認コードを入力してください。',
  twofa_code_placeholder: '6桁のコードまたはバックアップコード',
  twofa_send_code: 'コードを送信',
  twofa_primary_updated: 'デフォルトの確認方法を更新しました。',
  twofa_disabled: '二要素認証がオフになりました。',
  twofa_enabled: '二要素認証がオンになりました。',
  twofa_totp_help: 'Google Authenticator、Authy、1PasswordでこのQRコードを読み取ってください。キーを手動入力することもできます。',
  twofa_secret_copied: 'キーをコピーしました',
  twofa_sms_help: '国際形式で携帯電話番号を入力してください。6桁のコードをSMSで送ります。',
  twofa_email_help: 'アカウントのメールに6桁のコードを送ります。',
  twofa_backup_title: 'バックアップコード',
  twofa_backup_help: 'これらのワンタイムコードを安全な場所に保管してください。電話をなくした場合、各コードは1回だけ使えます。',
  twofa_copy_codes: 'コードをコピー',
  twofa_codes_copied: 'バックアップコードをコピーしました',
  twofa_regenerate: '新しいバックアップコードを取得',
  twofa_regenerate_hint: '未使用のバックアップコードが置き換わります。パスワードと現在のコードを入力してください。',
  twofa_backup_remaining: '未使用のバックアップコードが {n} 件残っています',
  twofa_new_codes: '新しいバックアップコード',
  twofa_sms_unavailable: 'SMSコードはまだ利用できません。',
  todoist_sync_title: "Todoist",
  todoist_sync_info: "割り当てられた Kjuup のタスクは、Todoist の「Kjuup」プロジェクトにコピーされます。Todoist 側の変更は反映されません。",
  todoist_connect: "Todoist を接続",
  todoist_connected: "Todoist を接続しました",
  todoist_connect_failed: "Todoist の接続に失敗しました",
  todoist_disconnect: "切断",
  todoist_disconnected: "Todoist を切断しました",
  todoist_disconnect_confirm: "Todoist を切断しますか？すでに Todoist にあるタスクはそのまま残ります。同期は停止します。",
  todoist_sync_now: "今すぐ同期",
  todoist_syncing: "同期しています…",
  todoist_sync_done: "同期が完了しました",
  todoist_sync_failed: "同期に失敗しました",
  todoist_auth_error: "同期を続けるには Todoist を再接続してください。",
  todoist_last_sync: "最終同期",
  todoist_not_connected: "Todoist は接続されていません",
  todoist_auth_url_failed: "Todoist の認可ページを開けませんでした。",
  recommend_text: "Kjuupに参加して、いつでもつながり、コミュニケーションを整理しよう。チャネルをひとつにまとめ、メッセージを正しいプロジェクトに置き、毎朝サマリーとタスクで一日をスタート——すべていつも使っているアプリと同期。無料で始めよう：",
  pro_auth_signin_title: 'おかえりなさい',
  pro_auth_signin_sub: '勤務先のメールアドレスでサインインしてください。',
  pro_auth_email_or_username: 'メールまたはユーザー名',
  pro_auth_email_placeholder: 'name@company.de',
  pro_auth_forgot_password: 'パスワードをお忘れですか？',
  pro_auth_create_account: 'アカウントを作成',
  pro_auth_show_password: 'パスワードを表示',
  pro_auth_hide_password: 'パスワードを非表示',
  pro_auth_register_sub: 'メールアドレス確認用のリンクをお送りします。',
  pro_auth_register_plus_sub: 'ユーザー名とパスワードを選択してください。次にセキュリティPINを設定します。',
  pro_auth_check_credentials: 'メールアドレスとパスワードをご確認ください',
  pro_news_export_pdf: 'PDFとしてエクスポート',
  pro_news_pdf_failed: 'PDFを作成できませんでした。',
  pro_news_pdf_attachments: '添付ファイル',
  pro_news_pdf_video: '動画',
  pro_auth_forgot_sub: 'メールアドレスを入力してください。パスワード再設定用のリンクをお送りします。',
  pro_auth_send_link: '再設定リンクを送信',
  pro_auth_plus_reset: 'PINで再設定',
  pro_auth_show_pin: 'PINを表示',
  pro_auth_hide_pin: 'PINを非表示',
  v2_auth_plus_only: 'Kjuup+のみ',
  room_action_media: "ファイル",
  room_tab_overview: "概要",
  room_tab_history: "履歴",
  chat_info_media: "ファイル",
  messages: "メッセージ",
  pro_todo_project_required: "プロジェクトを選択してください",
  pro_todo_choose_project: "このタスクはどのプロジェクト用ですか？",
  cockpit_report_delete_confirm: "このデイリーレポートを削除しますか？",
  cockpit_report_deleted: "デイリーレポートを削除しました",
  cockpit_tab_company: "会社",
  cockpit_bookmarked_priorities: "ブックマークしたタスク",
  cockpit_load_error: "コックピットを読み込めませんでした。",
  cockpit_retry: "再試行",
  cockpit_yesterday: "昨日",
  cockpit_greeting_morning: "おはようございます",
  cockpit_greeting_day: "こんにちは",
  cockpit_greeting_evening: "こんばんは",
  cockpit_assistant_q_open: "今日の未完了は？",
  cockpit_assistant_q_summarize: "チャット {{room}} を要約",
  cockpit_assistant_q_overdue: "期限超過のタスクは？",
  cockpit_assistant_new: "新着 {{n}} 件",
  cockpit_assistant_important: "重要 {{n}} 件",
  cockpit_assistant_title: "Kjuup アシスタント",
  cockpit_assistant_hint: "タップして質問",
  room_overview_priority_no_detail: "このレポートには、この重点事項の詳細がありません。",
  room_overview_priority_from: "ソース: {{name}}",
  room_overview_priority_open_task: "タスクを開く",
  cockpit_priority_position: "優先事項 {{index}} / {{total}}",
  room_overview_today_title: "今日の重要事項",
  room_overview_all_tasks: "すべて",
  room_overview_tasks_empty: "未完了の期限やタスクはありません",
  room_overview_appointments_empty: "予定されているアポイントはありません",
  room_overview_no_priorities: "最新のレポートに未完了の重点事項はありません。",
  cockpit_report_top5: "重点事項トップ5",
  cockpit_report_todo_created: "タスクを作成しました",
  cockpit_report_source_missing: "元のメッセージが見つかりませんでした。",
  delete_bookmarked_priority_confirm: "このブックマークしたタスクを削除してもよろしいですか？",
  cockpit_report_create_todo: "タスクを作成",
  cockpit_priorities_deleting: "削除中 …",
  cockpit_priorities_select: "複数を削除",
  cockpit_report_none: "項目はありません。",
  cockpit_priorities_delete_confirm: "ブックマークしたタスク {count} 件を削除してもよろしいですか？",
  cockpit_priorities_delete_failed: "{count} 件のタスクを削除できませんでした",
  cockpit_priorities_deleted: "{count} 件のタスクを削除しました",
  cockpit_priorities_selected: "{count} 件選択中",
  cockpit_channel_connected: "接続済み",
  cockpit_channel_not_connected: "未接続",
  cockpit_channel_connect: "接続",
  cockpit_channel_chat: "Kjuup チャット",
  cockpit_channel_active: "有効",
  cockpit_channel_hidden: "非表示",
  cockpit_channel_enable: "有効にする",
  cockpit_channel_email: "メール",
  cockpit_channel_check: "接続を確認",
  cockpit_channel_fix: "確認",
  cockpit_channel_forward: "転送アドレス",
  cockpit_channel_not_set_up: "未設定",
  cockpit_channel_set_up: "設定",
  cockpit_channel_teams: "Microsoft Teams",
  cockpit_channel_broken: "接続が切断されました",
  cockpit_channel_importing: "インポート中",
  cockpit_channel_removing: "接続を解除中",
  cockpit_channel_reconnect: "再接続",
  cockpit_channels_title: "チャンネル",
  cockpit_company_role_super_admin: "会社管理者",
  cockpit_company_role_dept_admin: "部門管理者",
  cockpit_company_role_member: "従業員",
  cockpit_company_none: "Kjuup+ の会社が見つかりません",
  cockpit_company_eyebrow: "会社",
  cockpit_company_inactive: "無効",
  cockpit_company_settings: "会社設定",
  cockpit_company_employees: "従業員",
  cockpit_company_internal_rooms: "社内プロジェクト",
  cockpit_report_all_projects: "すべてのプロジェクト",
  cockpit_report_progress_emails: "メールを分析中",
  cockpit_report_progress_chats: "チャットメッセージを分析中",
  cockpit_report_progress_documents: "添付ファイルとドキュメントを分析中",
  cockpit_report_progress_tasks: "タスクを分析中",
  cockpit_report_progress_summarizing: "内容を分析中",
  cockpit_report_progress_reading: "分析済みの内容を再利用中",
  cockpit_report_progress_collecting: "プロジェクトからメール、チャット、タスクを収集中",
  cockpit_report_progress_priorities: "重点事項、期限、決定事項をまとめ中",
  cockpit_report_progress_queued: "レポートを準備中",
  cockpit_report_creating_title: "デイリーレポートを作成中です",
  cockpit_report_progress_count_one: "1 件を分析済み",
  cockpit_report_progress_count_many: "{{count}} 件を分析済み",
  cockpit_report_progress_hint: "通常1～2分かかります。その間もコックピットを引き続きご利用いただけます。",
  cockpit_report_time_hint: "デイリーレポートは、最もアクティブな5つのプロジェクトについて毎日 {{hour}}:00 に作成されます。",
  room_overview_priorities_title: "現在の状況と重点事項",
  room_overview_as_of: "{{time}} 時点",
  cockpit_report_delete: "デイリーレポートを削除",
  email_tag_daily_briefing: "デイリーレポート",
  cockpit_report_unread: "新規",
  cockpit_report_clear_project: "すべてのプロジェクトを表示",
  cockpit_filter_project: "プロジェクト",
  cockpit_filter_all_projects: "すべてのプロジェクト",
  cockpit_report_recreate: "デイリーレポートを再作成",
  cockpit_report_hide_previous: "過去のデイリーレポートを非表示",
  cockpit_report_show_previous: "過去のデイリーレポートを表示",
  cockpit_report_room_empty: "このプロジェクトのデイリーレポートはまだありません",
  cockpit_report_empty: "デイリーレポートはまだありません",
  cockpit_report_room_empty_hint: "このプロジェクトのみのデイリーレポートを作成します。",
  cockpit_report_needs_mailbox: "Kjuup が自動タスク付きのデイリーレポートを作成できるよう、メールアカウントを接続してください。",
  cockpit_report_create: "デイリーレポートを作成",
  cockpit_email_connect: "メールを接続",
  cockpit_email_none_title: "メールアカウントが未接続です",
  cockpit_email_none_reports: "メールボックスを接続すると、Kjuup が受信メールをプロジェクトに振り分け、タスク付きのデイリーレポートを作成します。",
  cockpit_email_none_client: "Gmail、Outlook、IMAP を接続して、Kjuup.io 上でメールの閲覧・振り分け・返信ができます。",
  cockpit_email_reports_title: "現在のメールクライアント",
  cockpit_email_reports_text: "Kjuup.io に受信トレイなし · {{rooms}} 件のプロジェクトで {{hour}}:00 にデイリーレポート · 受信メールはプロジェクトに振り分けられます。",
  cockpit_email_reports_rooms: "プロジェクトを管理",
  cockpit_email_settings: "メール設定",
  cockpit_email_error_title: "接続を確認",
  cockpit_email_client_title: "受信トレイ接続済み",
  cockpit_email_accounts_n: "{{n}} 件のアカウントを接続済み",
  cockpit_email_last_sync: "最終同期 {{when}}",
  cockpit_email_report_at: "デイリーレポート {{hour}}:00",
  cockpit_email_open_inbox: "受信トレイを開く",
  cockpit_email_eyebrow: "Kjuup メール",
  cockpit_email_accounts_label: "接続済みのメールアドレス",
  email_folder_sent: "送信済みアイテム",
  email_no_subject: "（件名なし）",
  cockpit_email_detail_loading: "メールを読み込み中 …",
  cockpit_email_detail_failed: "メールを読み込めませんでした。",
  cockpit_email_detail_empty: "このメールには本文がありません。",
  cockpit_personal_settings: "個人設定",
  cockpit_companies: "会社",
  cockpit_title: "コックピット",
  cockpit_back: "概要に戻る",
  cockpit_day_overview: "今日の概要",
  email_saved_to_project: "メールをプロジェクトに保存しました",
  email_classify_need_project: "プロジェクト名を入力してください",
  cockpit_email_deleted: "メールを削除しました",
  cockpit_email_sent_empty: "送信済みメールはまだありません。",
  cockpit_email_incoming_empty: "受信メールはまだありません。",
  cockpit_email_incoming_title: "メール",
  cockpit_email_incoming_sub: "受信メールと送信メールをプロジェクトに振り分けます。ここで振り分けを調整できます。",
  cockpit_email_incoming_unassigned_n: "{{n}} 件未振り分け",
  cockpit_email_folder_inbox: "受信トレイ",
  cockpit_email_folder_sent: "送信済み",
  cockpit_email_open: "メールを開く",
  cockpit_email_incoming_suggested: "候補: {{room}}",
  cockpit_email_incoming_apply: "適用",
  cockpit_email_incoming_adjust: "振り分けを調整",
  cockpit_email_incoming_saving: "保存中 …",
  cockpit_email_incoming_unassigned: "未振り分け",
  cockpit_email_incoming_show_less: "表示を減らす",
  cockpit_email_incoming_show_all: "すべて表示（{{n}} 件）",
  cockpit_io_settings: "Kjuup.io 設定",
  cockpit_io_settings_sub: "プランとシート、従業員の割り当て、請求と請求書。",
  products_coming_soon: "近日公開",
  cockpit_upsell_io_title: "先回りしてくれるあなたのオフィス",
  cockpit_upsell_io_text: "メールアカウントを Kjuup に接続します。メール、添付ファイル、メッセージは該当するプロジェクトに自動保存され、任意でお使いのサーバーにも保管できます。毎日、すべての内容の要点をまとめた全プロジェクトの要約が届き、タスクはカレンダーや ToDo アプリと同期されます。",
  cockpit_upsell_io_soon_title: "まだ申し込めません",
  cockpit_upsell_io_soon_text: "Kjuup.io はまもなく開始します。今すぐ情報をリクエストしてください。お申し込みが可能になり次第お知らせします。",
  cockpit_upsell_io_planned_price: "予定価格",
  cockpit_upsell_io_cta_request: "情報をリクエスト",
  kjuup_plus_abo_per_year: "/ 年",
  kjuup_plus_abo_per_month: "/ 月",
  kjuup_plus_abo_status_active: "有効",
  kjuup_plus_abo_status_requested: "解約リクエスト済み",
  kjuup_plus_abo_status_past_due: "支払い期限",
  kjuup_plus_abo_eyebrow: "Kjuup+ · サブスクリプション",
  kjuup_plus_abo_title: "Kjuup+ パッケージ",
  kjuup_plus_abo_seats_free_one: "残り 1 シート",
  kjuup_plus_abo_billing: "請求",
  kjuup_plus_abo_yearly: "年払い",
  kjuup_plus_abo_monthly: "月払い",
  kjuup_plus_abo_amount: "金額",
  kjuup_plus_abo_ends: "終了日",
  kjuup_plus_abo_renews: "次回更新",
  kjuup_plus_abo_next_invoice: "次回の請求書",
  kjuup_plus_abo_intro: "導入価格",
  kjuup_plus_abo_pending_tier: "次回更新から",
  kjuup_plus_abo_manual: "お客様の会社では、個別契約により Kjuup+ が有効になっています。",
  kjuup_plus_abo_invoices: "請求書",
  kjuup_plus_abo_invoice_paid: "支払い済み",
  kjuup_plus_abo_invoice_view: "表示",
  kjuup_plus_abo_invoices_less: "表示を減らす",
  kjuup_plus_abo_member_hint: "請求と解約は会社の管理者が管理します。",
  kjuup_plus_abo_withdraw: "リクエストを取り消す",
  kjuup_plus_abo_cancel_note: "理由（任意）",
  kjuup_plus_abo_cancel_send: "解約をリクエスト",
  kjuup_plus_abo_cancel: "サブスクリプションを解約",
  cockpit_upsell_plus_f1: "全従業員のコミュニケーション活動を管理",
  cockpit_upsell_plus_f2: "社内の特定のユーザーグループに通知",
  cockpit_upsell_plus_f3: "社内グループチャットを保存",
  cockpit_upsell_plus_when_yearly: "年払いの場合",
  cockpit_upsell_plus_size_small: "従業員 1～50 名",
  cockpit_upsell_plus_size_large: "従業員 51～200 名",
  cockpit_upsell_plus_title: "企業向け Kjuup+",
  cockpit_upsell_plus_text: "従業員、書き込み権限、社内コミュニケーションを一元管理。社内チャンネルはチーム内に留まり、社外チャンネルはプロジェクトパートナーとつながり、特定のグループに直接連絡できます。Kjuup+ に加えて、従業員グループ向けの Kjuup.io アクセスも申し込めます。Kjuup+ と Kjuup.io は組み合わせて利用できます。",
  cockpit_upsell_plus_size: "会社の規模",
  cockpit_upsell_plus_billing: "請求",
  cockpit_upsell_plus_per_company: "/ 会社 · 月（税別）",
  cockpit_upsell_plus_onboarding: "導入・初期費用は会社の規模によって異なります",
  cockpit_upsell_plus_larger: "より大規模な会社の料金はお問い合わせください",
  cockpit_upsell_plus_cta: "お気軽にお問い合わせください",
  cockpit_kpi_deadlines_tasks: "期限とタスク",
  cockpit_kpi_appointments: "予定",
  cockpit_room_admin: "プロジェクト＆チャット管理",
  cockpit_room_admin_sub: "メンバー、メディア、チャット付きの全社プロジェクト。",
  pro_todo_not_found: "このタスクは利用できなくなりました。",
  cockpit_chip_overdue: "期限超過",
  cockpit_chip_today: "今日",
  cockpit_calendar_week: "第{{week}}週",
  cockpit_prev_week: "前の週",
  cockpit_next_week: "次の週",
  cockpit_chip_requested: "リクエスト済み",
  cockpit_todo_due: "期限 {{when}}",
  cockpit_todo_at: "{{time}}",
  cockpit_todo_requested_from: "{{name}} から",
  cockpit_todo_since: "{{when}} から",
  cockpit_todo_no_date: "日付なし",
  cockpit_todo_mark_done: "完了にする",
  cockpit_my_tasks_title: "自分のタスク",
  cockpit_today_tasks_group: "今日のタスク",
  cockpit_assign_none: "担当者なし",
  no_project_found: "プロジェクトが見つかりません",
  cockpit_row_more_actions: "その他の操作",
  needs_date: "日付を割り当て",
  cockpit_assign_proposal: "{{name}} を検出しました。割り当てますか？",
  cockpit_assign_proposal_confirm: "割り当てる",
  cockpit_assign_proposal_dismiss: "無視",
  cockpit_priority_date: "日付",
  todo_calendar_add: "カレンダーに追加",
  todo_calendar_remove: "カレンダーから削除",
  cockpit_todo_change_project: "プロジェクトを変更",
  cockpit_todo_set_date: "日付を設定",
  pro_todo_done_confirm: "このタスクを完了にしてもよろしいですか？",
  cockpit_task_delete_failed: "タスクを削除できませんでした。",
  cockpit_setup_title: "セットアップを完了",
  cockpit_setup_text: "チャットを使うか、Kjuup.io をメールクライアントとして使うか、プロジェクトとデイリーレポートのみで使うかを選択してください。",
  cockpit_setup_cta: "今すぐ設定",
  cockpit_group_tasks: "期限とタスク",
  cockpit_group_appointments: "予定",
  cockpit_report_no_activity: "このプロジェクトでは、過去24時間に新しいメッセージやメールはありませんでした。",
  cockpit_report_room_unavailable: "このプロジェクトは利用できません。",
  cockpit_report_create_failed: "デイリーレポートを作成できませんでした。",
  cockpit_report_created: "デイリーレポートを作成しました",
  addon_enable_confirm: "アドオンを有効にしますか？",
  addon_enable: "有効にする",
  addon_enabled: "アドオンを有効にしました",
  nav_email: "メール",
  nav_my_cockpit: "マイコックピット",
  nav_news: "ニュース",
  nav_recommend: "おすすめ",
  pro_todo_status_done: "完了",
  pro_todo_status_open: "未完了",
  v2_todo_remove: "削除",
  pro_todo_search_people: "ユーザーを検索",
  pro_todo_clear: "クリア",
  pro_todo_assigned: "（割り当て済み）",
  pro_todo_no_people: "ユーザーが見つかりません",
  pro_todo_search_rooms: "プロジェクトを検索",
  pro_todo_no_rooms_match: "「{{q}}」に一致するプロジェクトはありません",
  pro_todo_no_rooms: "プロジェクトが見つかりません",
  pro_todo_activity: "アクティビティ",
  pro_todo_show_less: "表示を減らす",
  pro_todo_show_all: "すべて表示（{{n}}）",
  pro_todo_due: "期限",
  pro_todo_room: "プロジェクト",
  pro_todo_select_room: "プロジェクトを選択",
  pro_todo_status: "ステータス",
  pro_todo_more: "その他",
  pro_todo_edit_title: "タスクを編集",
  pro_todo_description: "説明",
  pro_todo_created_by: "作成者",
  pro_todo_chat: "チャット",
  navigate_to_source: "ソースへ移動",
  todo_calendar_connect_title: "カレンダーが未接続です",
  todo_calendar_connect_body_web: "カレンダー同期設定でカレンダーを接続すると、ToDo を追加できます。",
  todo_calendar_connect: "接続",
  todo_calendar_removed: "カレンダーから削除しました",
  todo_calendar_added_later: "追加しました。カレンダーに接続できなかったため、Kjuup が後ほど再試行します。",
  todo_calendar_added: "カレンダーに追加しました",
  todo_calendar_no_date: "カレンダーに追加できるのは日付のある ToDo のみです。",
  todo_calendar_failed: "カレンダーを更新できませんでした。もう一度お試しください。",
  todo_calendar_date_title: "日付がまだありません",
  todo_calendar_date_save: "日付を設定して追加",
  todo_calendar_date_body_web: "このブックマークしたタスクにはまだ日付がありません。カレンダーに追加するには日付を設定してください。",
  kjuup_io_setup_saved: "セットアップを保存しました",
  kjuup_io_setup_step: "ステップ",
  kjuup_io_setup_chats_title: "チャットを使いますか？",
  kjuup_io_setup_email_title: "メールはどこで読みますか？",
  kjuup_io_setup_chats_sub: "同僚やプロジェクトパートナーとのチャットは任意です。コックピットでいつでも表示・非表示を切り替えられます。",
  kjuup_io_setup_email_sub: "Kjuup 内のメールクライアントを使うか、Outlook などの現在のメールソフトを使い続けるかを選ぶだけです。後から変更できます。",
  kjuup_io_setup_chats_yes: "はい、チャットを表示",
  kjuup_io_setup_chats_yes_text: "メッセージにはチャットとメールが含まれます。プロジェクトには関係者全員のグループチャットがあります。",
  kjuup_io_setup_chats_no: "いいえ、チャットなしで使う",
  kjuup_io_setup_chats_no_text: "チャットは非表示になります。「メッセージ」は「メール」になり、プロジェクト、タスク、デイリーレポートはそのままです。",
  kjuup_io_setup_email_client: "Kjuup 内のメールクライアント",
  kjuup_io_setup_email_client_text: "Kjuup 内で直接メールを閲覧・返信します。",
  kjuup_io_setup_email_reports: "現在のメールクライアント",
  kjuup_io_setup_email_reports_text: "Outlook などの現在のソフトで引き続き閲覧・返信します。",
  kjuup_io_setup_skip: "後で",
  next: "次へ",
  kjuup_io_setup_finish: "セットアップを完了",
  today_label: "今日",
  tomorrow_label: "明日",
  cockpit_todo_overdue: "期限超過",
  cockpit_report_management_fazit: "マネジメントサマリー",
  cockpit_todo_appointment: "予定",
  cockpit_todo_deadline: "期限",
  cockpit_todo_deadline_define: "期限を設定",
  pro_todo_status_acknowledged: "確認済み",
  pro_todo_responsible: "担当者",
  pro_todo_notice_confirmed: "チャットで確認済み",
  pro_todo_notice_sent_at: "メッセージ送信済み",
  pro_todo_notice_again: "メッセージを再送信",
  pro_todo_notice_send: "Kjuup メッセージで通知",
  pro_todo_add_assignee: "追加",
  pro_todo_edit: "編集",
  pro_todo_change_room: "プロジェクトを変更",
  pro_todo_due_on: "期限日",
  pro_todo_edit_due: "期限日を編集",
  pro_todo_no_date: "日付なし",
  pro_todo_edit_description: "説明を編集",
  pro_todo_no_description: "説明はまだありません",
  pro_todo_title_label: "タイトル",
  pro_todo_title_placeholder: "タイトルを入力...",
  pro_todo_task: "タスク",
  pro_todo_what: "何をする必要がありますか？",
  pro_todo_source_email: "メール",
  pro_todo_sources: "ソース",
  previous: "前へ",
  kjuup_plus_abo_tier_large: "Kjuup+ Large（従業員 {max} 名まで）",
  kjuup_plus_abo_tier_small: "Kjuup+ Small（従業員 {max} 名まで）",
  kjuup_plus_abo_status_ends: "{date} に終了",
  kjuup_plus_abo_seats_over: "従業員が {max} 名を超える場合 – Kjuup から個別のお見積りをご連絡します。",
  kjuup_plus_abo_seats_next: "従業員が増えると、パッケージは自動的に {next} に切り替わります（日割り計算）。",
  kjuup_plus_abo_seats_used: "{total} シート中 {used} シート使用中",
  kjuup_plus_abo_seats_free: "残り {count} シート",
  kjuup_plus_abo_intro_until: "{date} まで",
  kjuup_plus_abo_invoice_open: "未払い · 期限 {date}",
  kjuup_plus_abo_invoices_all: "すべて表示（{count} 件）",
  kjuup_plus_abo_requested_hint: "{date} に解約をリクエストしました。Kjuup が契約期間の終了時（{end}）に確定します。",
  kjuup_plus_abo_cancel_hint: "Kjuup がリクエストを確認し、契約期間の終了時（{end}）に解約を確定します。それまで Kjuup+ は有効です。",
  kjuup_plus_abo_withdrawn: "解約リクエストを取り下げました",
  kjuup_plus_abo_requested: "解約をリクエスト済み",
  cockpit_upsell_plus_intro_hint: "最初の{months}か月、その後{price}",
  cockpit_upsell_plus_badge: "{months}か月間の導入価格",
  calendar_syncing: "カレンダーから更新中…",
  calendar_sync_up_to_date: "カレンダーは最新です",
  calendar_sync_failed: "同期に失敗しました",
  delete_multiple_tasks_confirm: "本当に{count}件のToDoを削除しますか？",
  todos_deleted_count: "{count}件のToDoを削除しました",
  todos_deleted_partial: "{ok}件のToDoを削除しました、{fail}件失敗",
  todo_unknown: "不明",
  todo_created_from_message: "このメッセージからタスクを作成しました",
  kjuup_io_todo_calendar_trial_ended_note: "カレンダー同期 · 購読する",
  kjuup_io_todo_calendar_nudge: "このToDoをカレンダーに同期しますか？",
  kjuup_io_todo_calendar_nudge_cta: "Kjuup.ioを有効化",
  todo_confirmed: "ToDo確認済み",
  pro_todo_bulk_delete_title: "{{n}} 件のタスクを削除しますか？",
  pro_todo_previous_none_own: "期限切れのタスクは他のユーザーから割り当てられたもので、そのユーザーしか削除できません。",
  pro_todo_previous_none: "期限切れのタスクはありません",
  pro_todo_previous_title: "期限切れのタスク {{n}} 件を削除しますか？",
  pro_todo_previous_text: "過去の日付の未完了タスクがすべて削除されます。",
  pro_todo_previous_skipped: "他のユーザーから割り当てられた {{n}} 件は残ります。",
  unassign_task_confirm: "このタスクから自分の割り当てを解除しますか？",
  unassign_label: "解除",
  pro_todo_delete_title: "タスクを削除",
  pro_todo_today: "今日",
  pro_todo_yesterday: "昨日",
  pro_todo_since_yesterday: "昨日以降",
  pro_todo_mark_open: "未完了にする",
  verify_completion: "確認",
  new_label: "新規",
  bookmarked_no_mylist: "ブックマークしたタスクはマイリストに追加できません",
  delete_only_own: "削除できるのは自分が作成したタスクのみです",
  todo_clear_all: "すべてクリア",
  pro_todo_of_completed: "{{total}} 件中 {{done}} 件完了",
  pro_todo_pick_date: "日付を選択",
  pro_todo_show_day: "日を表示",
  todo_adjust_list: "リストを調整",
  pro_todo_section_upcoming: "今後の予定",
  pro_todo_section_done: "完了",
  pro_todo_room_empty_today: "このプロジェクトに今日のタスクはありません",
  pro_todo_room_empty_day: "このプロジェクトにこの日のタスクはありません",
  pro_todo_delete_previous: "すべて削除",
  todo_my_list_empty: "今日の予定はありません",
  todo_my_list_empty_hint: "「リストを調整」をクリックしてタスクを追加",
  pro_todo_empty_title: "何もありません",
  pro_todo_empty_hint: "この表示に一致するタスクはありません。",
  pro_todo_selected: "{{n}} 件を選択中",
  delete_selected_count: "削除 ({count})",
  pro_todo_adjust_done: "完了",
  pro_todo_deleting: "削除中…",
  pro_todo_reopen: "タスクを再開",
  pro_todo_step_done: "完了",
  move_back_in_progress: "進行中に戻す",
  pro_todo_mark_not_started: "未着手にする",
  back_into_in_progress: "進行中に戻す",
  pro_todo_mark_in_progress: "進行中にする",
  unassign_todo: "ToDoの割り当てを解除",
  pro_todo_open_room: "プロジェクトを開く",
  pro_todo_new_task: "新しいタスク",
  select_user_back_to_in_progress: "進行中に戻すユーザーを選択",
  cockpit_email_accounts_n_many: "{{n}} 件のアカウントを接続済み",
  // Kjuup + Microsoft Teams chats (new-chat pickers, combined groups)
  combined_tab_kjuup: "Kjuup の連絡先",
  combined_tab_teams: "Teams の連絡先",
  combined_bridge_failed: "Teams のコピーを作成できませんでした。",
  combined_chat_label: "Kjuup + Teams",
  combined_guest_tag: "Teams",
  combined_new_group_note: "Kjuup と Teams の連絡先：Microsoft Teams にも表示される新しいグループが作成されます。",
  teams_new_chat_title: "新しい Teams チャット",
  teams_new_chat_topic: "グループ名（任意）",
  teams_new_chat_start: "チャットを開始",
  teams_new_chat_creating: "チャットを作成中…",
  teams_new_chat_forbidden: "Microsoft Teams ではこのチャットは許可されていません（例：組織外のユーザーや IT 部門のポリシー）。",
  teams_new_chat_too_many: "1 つのチャットには人数が多すぎます。",
  teams_new_chat_type_hint: "組織内を検索するには名前を入力してください。",
  teams_new_chat_directory_forbidden: "組織でディレクトリ検索が許可されていません。Teams チャットのユーザーのみ表示されます。",
  teams_new_chat_account: "アカウント",
};
